import { emailValidationError } from '@theme/theme-global';

class NewsletterForm extends HTMLFormElement {
  constructor() {
    super();
    this.emailInput = this.querySelector('input[type="email"]');
    this.submitButton = this.querySelector('button[name="commit"]');
    this.emailRegex = /^[^\s@]+@[^\s@]+\.[\p{L}0-9-]{2,}$/u;
  }

  get warningIcon() {
    const label = window.accessibilityStrings?.warning || 'Warning';
    return `<svg class="icon-small" role="img" aria-label="${label}" viewBox="0 0 24 24" focusable="false">
          <path fill="rgb(var(--warningColor))" d="M12 2 2 20h20L12 2z"/>
          <rect x="11" y="8" width="2" height="6" fill="rgb(var(--warningBackground))" rx="0.4"/>
          <rect x="11" y="16" width="2" height="2" fill="rgb(var(--warningBackground))" rx="0.3"/>
        </svg>`;
  }
  connectedCallback() {
    this.submitButton.addEventListener('click', this.onSubmit.bind(this));
  }

  disconnectedCallback() {
    this.submitButton.removeEventListener('click', this.onSubmit.bind(this));
  }

  onInputChange(event) {
    if (this.emailInput.value.trim() === '' || !this.emailRegex.test(this.emailInput.value)) {
      this.submitButton.setAttribute('disabled', 'disabled');
    } else {
      this.submitButton.removeAttribute('disabled');
    }
  }

  async onSubmit(event) {
    event.preventDefault();
    const emailValue = this.emailInput.value;

    if (!this.emailRegex.test(emailValue)) {
      // Remove existing warning if any
      const existingWarning = this.querySelector('[data-info-message]');
      if (existingWarning) {
        existingWarning.remove();
      }

      // Clear any existing timeout
      if (this.warningTimeout) {
        clearTimeout(this.warningTimeout);
      }
      const errorMessage = emailValidationError(emailValue);
      this.insertAdjacentHTML(
        'beforeend',
        `<p class="d-flex align-items-center gap-1 form-message-small form-message-warning mt-10" data-info-message="true">${this.warningIcon}${errorMessage}</p>`,
      );
      // Store reference to the warning element
      const warningElement = this.querySelector('[data-info-message]');

      // Remove warning after 5 seconds
      this.warningTimeout = setTimeout(() => {
        if (warningElement && warningElement.parentNode) {
          warningElement.remove();
        }
      }, 5000);
      return;
    } else {
      this.submit();
    }
  }
}
if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsletterForm, { extends: 'form' });
}
